import { render, staticRenderFns } from "./SetupPaymentMethodBanner.vue?vue&type=template&id=404f6fc1&scoped=true&"
import script from "./SetupPaymentMethodBanner.vue?vue&type=script&lang=js&"
export * from "./SetupPaymentMethodBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404f6fc1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBanner } from 'vuetify/lib/components/VBanner';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBanner,VBtn})
